import React from "react";
import { useSearchParams } from "react-router-dom";

interface PmAddRouteWrapperProps {
  returnPath: string;
  children: (props: {
    returnPath: string;
    returnSearch: string;
  }) => React.ReactNode;
}

/** Passes hub filter query string from add-route URL back to create forms for bookmarkable return navigation. */
const PmAddRouteWrapper: React.FC<PmAddRouteWrapperProps> = ({
  returnPath,
  children,
}) => {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  const returnSearch = qs ? `?${qs}` : "";

  return <>{children({ returnPath, returnSearch })}</>;
};

export default PmAddRouteWrapper;
